module.exports = __webpack_public_path__ + "0-es5.cd598d7b61af4552ad61.worker.js"